export type TRefreshOutcome = 'success' | 'auth-failure' | 'network-failure';

export interface ApiCallErrorOptions {
  body?: unknown;
  cause?: unknown;
  status?: number;
  url?: string;
  reported?: boolean;
  refreshOutcome?: TRefreshOutcome;
}

export class ApiCallError extends Error {
  public readonly body: unknown;
  public readonly cause: unknown;
  public readonly status: number | undefined;
  public readonly url: string | undefined;
  public readonly reported: boolean;
  public readonly refreshOutcome: TRefreshOutcome | undefined;

  constructor(message: string, options: ApiCallErrorOptions = {}) {
    super(message);
    this.name = 'ApiCallError';
    this.body = options.body;
    this.cause = options.cause;
    this.status = options.status;
    this.url = options.url;
    this.reported = options.reported ?? false;
    this.refreshOutcome = options.refreshOutcome;
    Object.setPrototypeOf(this, ApiCallError.prototype);
  }
}
